// components/MasterForm.jsx
import React, { useState } from "react";

const Form = ({
  show,
  onClose,
  onSubmit,
  name,
  setName,
  editId,
  tab,
}) => {
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const handleSubmit = async () => {
    if (!name.trim()) return; // optional: prevent empty submission
    setLoading(true);
    try {
      await onSubmit(); // assuming onSubmit is async
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-10">
      <div className="bg-white p-6 rounded shadow-md w-96">
        <h3 className="text-lg font-bold mb-4">
          {editId ? `Edit ${tab}` : `Add ${tab}`}
        </h3>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full border px-3 py-2 rounded mb-4"
          placeholder={`Enter ${tab}`}
        />
        <div className="flex justify-end gap-2">
          <button
            onClick={handleSubmit}
            className={`px-4 py-2 rounded text-white ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600"}`}
            disabled={loading}
          >
            {loading ? (editId ? "Updating..." : "Adding...") : editId ? "Update" : "Add"}
          </button>
          <button
            onClick={onClose}
            className="bg-gray-300 px-4 py-2 rounded"
            disabled={loading} // optional: prevent closing during submit
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default Form;
